import React, { FunctionComponent, ReactNode } from "react";
import { Typography, Button } from "@material-ui/core";
import CallToActionButton from "components/callToActionButton";
import DynamicImage from "components/dynamicImage";
import "./index.scss";
import ContentHTMLItem from "components/content/ContentHTMLItem";
import ContentTextItem from "components/content/ContentTextItem";
import ContentItem from "components/content/ContentItem";
import EmblaCarousel from "../../components/EmblaCarousel";
import { Image } from "../../services/entities/content";
import { Link } from "../../config/components";
import NextRouteURLs from "NextRouteURLs";

type BannerProps = {
  title?: string | any;
  subTitle?: string | any;
  text?: string | any;
  link?: Link | undefined;
  images?: URL | Image | Image[] | null;
  children?: ReactNode;
  enquire?: boolean;
  code?: string;
};

export const Banner: FunctionComponent<BannerProps> = ({
  title,
  subTitle,
  link = {
    url: "",
    label: "",
  },
  text = "",
  images,
  children,
  enquire,
  code,
}) => {
  const onContactClick = () => {
    window.location.href = NextRouteURLs.CONTACT
  };

  return (
    <span className="section-mw">
      <section className={`section--banner content-mw`}>
        <span className="banner-image">
          {images && (images as URL) && images && !Array.isArray(images) && (
            <div className="image-wrapper">
              <img src={(images as URL).href} alt="" />
            </div>
          )}

          {images && (images as Image[] | Image) && Array.isArray(images) && (
            <EmblaCarousel
              loop={true}
              hasDots={false}
              largeNavArrows={false}
              align={1}
              hasThumbs={false}
            >
              {(images as Image[]).map((item: Image) => {
                return (
                  item && (
                    <div className="image-wrapper" key={item.url}>
                      <img src={item.url} alt="" />
                    </div>
                  )
                );
              })}
            </EmblaCarousel>
          )}
          <ContentItem code="bannerImage">
            {(item) => {
              return item && <DynamicImage item={item} />;
            }}
          </ContentItem>
        </span>
        <Typography variant="h1" component="h1" className="title">
          {title ? title : <ContentTextItem code="bannerTitle" />}
        </Typography>

        <span className="brand-logo">
          <ContentItem code="bannerLogo">
            {(item) => {
              return item && <DynamicImage item={item} />;
            }}
          </ContentItem>
        </span>

        {text ? (
          <Typography
            variant="body1"
            component="div"
            className="text"
            dangerouslySetInnerHTML={{ __html: text }}
          />
        ) : (
          <Typography variant="body1" component="div" className="text">
            <ContentHTMLItem code="bannerText" />
          </Typography>
        )}

        <CallToActionButton code={"bannerLink"} />
        {enquire && code && (
          <Button
            id={`${code}-enquire-banner`}
            className="button"
            size="small"
            variant="contained"
            color="primary"
            onClick={(e) => onContactClick()}
          >
            Check Availability
          </Button>
        )}
        {children}
      </section>
    </span>
  );
};

export default Banner;
